module.exports = __webpack_public_path__ + "img/src/components/Receipt/question.svg?4ca2d442";